import { render } from "./upload_avatar.vue?vue&type=template&id=6220dff6&scoped=true"
import script from "./upload_avatar.vue?vue&type=script&lang=js"
export * from "./upload_avatar.vue?vue&type=script&lang=js"

import "./upload_avatar.vue?vue&type=style&index=0&id=6220dff6&scoped=true&lang=css"
import "./upload_avatar.vue?vue&type=style&index=1&id=6220dff6&lang=css"

import exportComponent from "E:\\devops.aliyun\\liangting\\liangting_pms_web\\pms_web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6220dff6"]])

export default __exports__